import React, { memo, useState, useEffect, useMemo } from 'react'
import { Fade } from 'react-reveal'
import debounce from 'lodash.debounce'
import { Loader } from './Spinner'

/**
 * AUTOCOMPLETE ADRESS FROM DATA GOUV FR
 * @param {{query: string, name: string, setValue: (name: string) => void, showItems: boolean }} props 
 * @returns {JSX.Element}
 */
function AutoCompleteAddress({ query, setValue, name, showItems }) {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)

  const fetchAddress = async () => {
    try {
      setLoading(true)
      const res = await fetch(`https://api-adresse.data.gouv.fr/search/?q=${encodeURIComponent(query)}&type=housenumber&autocomplete=1`)
      const data = await res.json()
      setLoading(false)
      setData(data.features)
    } catch (error) {
      setLoading(false)
      console.log(error);
    }
  }

  const debouncedChangeHandler = useMemo(() => debounce(fetchAddress, 300), [query])

  useEffect(() => {
    if (!query) return null
    debouncedChangeHandler()
  }, [query])

  const _selectAdress = (adressSelected) => {
    setValue(name, adressSelected)
  }

  if (!query) return null
  return (
    <Fade>
      <ul className={`bg-white border-[1px] rounded-2xl shadow-lg max-h-[300px] overflow-y-auto absolute z-50 w-full list-autocomplete ${showItems ? '' : 'hidden'}`}>
        {loading && data.length <= 0 && <div className="p-5"><Loader /></div>}
        {
          data.map((adress, key) => {
            return <Fade bottom key={key}>
              <li className="group min-h-12 w-full border-b px-4 py-3 border-gray-200 flex flex-col justify-center hover:bg-teal-50 hover:text-general-teal transition-colors cursor-pointer" onClick={() => _selectAdress(adress.properties.label)}>
                <h5 className='font-bold text-sm'>{adress.properties.label}</h5>
                <p className='text-gray-500 group-hover:text-teal-800 text-sm'>{adress.properties.context}</p>
              </li>
            </Fade>
          })
        }
      </ul>
    </Fade>
  )
}

export default memo(AutoCompleteAddress)
